export default __webpack_public_path__ + "static/media/docs2.2157b85f.svg";